import { render, staticRenderFns } from "./vsSidebarItem.vue?vue&type=template&id=e0d0d3ca"
import script from "./vsSidebarItem.vue?vue&type=script&lang=js"
export * from "./vsSidebarItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports